import React from 'react';
import '../../Styles/Layout/Skeletons.css'

export const UserMessageSkeleton = ({ variant = 'default' }: { variant?: 'short' | 'medium' | 'long' | 'default' }) => {
  return (
    <div className="message-skeleton-wrapper">
      <div className={`message user skeleton ${variant}`}></div>
    </div>
  );
};

export const AIMessageSkeleton = ({ variant = 'default' }: { variant?: 'short' | 'medium' | 'long' | 'default' }) => {
  return (
    <div className="ai-message-skeleton-wrapper">
      <div className={`message ai skeleton ${variant}`}>
        <div className="ai-skeleton-content">
          <div className="ai-skeleton-line line-1"></div>
          <div className="ai-skeleton-line line-2"></div>
          <div className="ai-skeleton-line line-3"></div>
          {variant === 'long' && (
            <>
              <div className="ai-skeleton-line line-4"></div>
              <div className="ai-skeleton-line line-5"></div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export const MessagesSkeleton = () => {
  const userVariants = ['short', 'medium', 'short', 'medium'] as const; // More conservative sizes
  const aiVariants = ['medium', 'medium', 'long', 'medium'] as const; // Mostly medium to avoid jumps
  
  return (
    <div className="messages-skeleton">
      {[1, 2, 3, 4].map((i) => {
        return (
          <React.Fragment key={i}>
            <UserMessageSkeleton variant={userVariants[i - 1]} />
            <AIMessageSkeleton variant={aiVariants[i - 1]} />
          </React.Fragment>
        );
      })}
    </div>
  );
};

export const SingleMessageSkeleton = () => {
  return (
    <div className="messages-skeleton">
      <UserMessageSkeleton variant="medium" />
      <AIMessageSkeleton variant="long" />
    </div>
  );
};

export const StudySpacesSkeleton = () => {
  return (
    <div className="spaces-skeleton-container">
      <div className="spaces-skeleton-cards">
        {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
          <div key={i} className="space-skeleton-card" />
        ))}
      </div>
    </div>
  );
};